<template>
  <div ref="dropdownContainer" class="dropdown" :class="{'is-active': !dropdownClosed}" @keydown="onKeydown">
    <div class="dropdown-trigger">
      <button class="button is-primary is-small" aria-haspopup="menu" :aria-expanded="!dropdownClosed" :aria-controls="dropdownMenuId" @click="toggleDropdown">
        <span>{{ title }}</span>
        <span class="caret" aria-hidden="true"></span>
      </button>
    </div>
    <div class="dropdown-menu" :id="dropdownMenuId">
      <div ref="dropdownContent" class="dropdown-content" :style="dropdownContentStyle">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, useId, useTemplateRef } from "vue";
import { useElementBounding, useEventListener, useWindowSize } from "@vueuse/core";

const props = defineProps({
  title: String
});

const dropdownMenuId = useId();
const dropdownClosed = ref(true);
const dropdownContainer = useTemplateRef("dropdownContainer");
const dropdownContent = useTemplateRef("dropdownContent");
const { height: windowHeight } = useWindowSize();
const { top: dropdownContentTop } = useElementBounding(dropdownContent);

const toggleDropdown = () => {
  dropdownClosed.value = !dropdownClosed.value;
};

const onKeydown = (e) => {
  switch (e.key) {
    case 'Escape':
      e.preventDefault();
      e.stopPropagation();
      dropdownClosed.value = true;
      break;
  }
};

useEventListener(document, 'click', (e) => {
  if (dropdownContainer.value && !dropdownContainer.value.contains(e.target)) {
    dropdownClosed.value = true;
  }
});

const dropdownContentStyle = computed(() => {
  let maxHeight = windowHeight.value - dropdownContentTop.value - 15;

  if (dropdownClosed.value || maxHeight < 200) {
    return {};
  }

  return {
    maxHeight: `${maxHeight}px`
  };
});

</script>

<style lang="scss" scoped>
  .caret {
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid white;
    margin-left: 0.5rem;
  }

  .dropdown-trigger .button {
    border-width: 1px;
    border-color: white;
  }

  .dropdown-content {
    width: max-content;
    max-height: 200px;
    overflow-y: auto;
  }

</style>